import { type ThemeDefinition } from 'vuetify';
import {
  vuetifyThemeConfig,
  type VuetifyThemeName,
  getCurrentConfigByDomain,
  windowService,
} from '~/domains/core';

export const themes = Object.values(vuetifyThemeConfig).reduce<
  Record<VuetifyThemeName, ThemeDefinition>
>((acc, { name, colors, variables, dark }) => {
  acc[name] = { colors, variables, dark };
  return acc;
}, {});

const hostname = windowService.getLocation().hostname;

export const resolveThemeByDomain = (): VuetifyThemeName => {
  const { currentConfig, defaultConfig } = getCurrentConfigByDomain(hostname);

  return currentConfig.theme ?? defaultConfig.theme;
};

export const defaultTheme = resolveThemeByDomain();
